import { Box } from "@mui/material";
import { OLClearIcon } from "components/CustomIcons/OLClearIcon";
import { Search } from "components/FormControls/Select/Search";
import { useMessage } from "hooks/intl";
import { useDebounce } from "hooks/useDebounce";
import { useEffect, useState } from "react";
import { SearchList } from "./SearchList";
import { useStyles } from "./styles";

interface Props {
  closeModal: () => void;
}

export const SearchModal = ({ closeModal }: Props) => {
  const [searchedValue, setSearchedValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isInitialLoad, setInitialLoad] = useState(true);
  const { debouncedValue: searchQuery, isTyping } = useDebounce(searchedValue);
  const { message } = useMessage();
  const classes = useStyles();

  useEffect(() => {
    if (isInitialLoad && searchedValue.length > 0) {
      setInitialLoad(false);
    }

    // eslint-disable-next-line
  }, [searchedValue]);

  return (
    <Box className={classes.modalContent}>
      <Box className={classes.searchAndCloseWrapper}>
        <Search
          className={classes.search}
          progressClassName={classes.loader}
          placeholder={message({ id: "globalSearch" }) + "..."}
          searchedValue={searchedValue}
          setSearchedValue={setSearchedValue}
          isLoading={isTyping || isSearching}
        />
        <OLClearIcon onClick={closeModal} />
      </Box>
      <SearchList
        searchValue={searchQuery}
        setIsSearching={setIsSearching}
        isInitialLoad={isInitialLoad}
        isSearching={isSearching}
      />
    </Box>
  );
};
